export default __webpack_public_path__ + "static/media/3.7d407d0b.webp";